// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"83":"24871183","518":"0c92f4e6"}[chunkId] + ".css";
};